// extracted by mini-css-extract-plugin
export default {"outcomes":"style__outcomes___fQr0c"};